import { observer } from "mobx-react";
import React, { memo, useEffect, useState } from "react";
import { Grid, Tooltip } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import TableComponent from "app/common/Component/Table/TableComponent";
import { getDateTime } from "app/common/LocalFunction";
import { PatientManagementStore } from "app/PatientManagement/PatientManagementStore";
const ListReviewFeedback = ({data}) => {
    const { t } = useTranslation();
    const {
            pageRegisterReviewFeedback,
            searchReviewFeedback,
            handleChangeFormSearchReviewFeedback,
            
        } = PatientManagementStore.reviewFeedbackStore;
    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <TableComponent
                    showOrdinalNumbers
                    titleNodata={t("noData")}
                    data={pageRegisterReviewFeedback?.content || []}
                    minWidth={"720px"}
                    name="ComplaintTab"
                    showMoreButton
                    columns={[
                        // {
                        //   title: t("action"),
                        //   field: "action",
                        //   align: "center",
                        //   width: "30px",
                        //   render: (row) => {
                        //     return (
                        //       <div className="flex-center gap-2">
                        //         {row?.status === 1 && (
                        //           <Tooltip title="Xóa khiếu nại" placement="top" arrow>
                        //             <div className="flex">
                        //               <IconDelete />
                        //             </div>
                        //           </Tooltip>
                        //         )}
                        //       </div>
                        //     );
                        //   },
                        // },
                        {
                        field: "client.code",
                        title: t("Mã khách hàng"),
                        },
                        {
                        field: "client.fullName",
                        title: t("Tên khách hàng"),
                        },
                        {
                        field: "clientPhoneNumber",
                        title: t("SĐT khách hàng"),
                        },
                        {
                        field: "mainContent",
                        title: t("Nội dung CSKH"),
                        },
                        {
                        field: "status",
                        title: t("Trạng thái"),
                        render: (row) => {
                            const statusMap = {
                            1: "Đang chờ xử lý",
                            2: "Đang xử lý",
                            3: "Đã phản hồi cho KH",
                            4: "Đã kết thúc phản hồi",
                            };
                            return statusMap[row.status] || "Không xác định";
                        },
                        },
                        {
                        field: "csAgent?.staffName",
                        title: t("Người xử lý hiện tại"),
                        render: (row) => row?.csAgent?.staffName || row?.agent?.staffName || "Chưa phân công",
                        },
                        {
                        field: "modifyDate",
                        title: t("Ngày sửa"),
                        render: (row) => getDateTime(row.modifyDate),
                        },
                        {
                        field: "note",
                        title: t("Ghi chú"),
                        },
                    ]}
                    dataPagination={{
                            pageIndex: searchReviewFeedback?.pageIndex,
                            pageSize: searchReviewFeedback?.pageSize,
                            totalElements: pageRegisterReviewFeedback?.totalElements,
                            totalPages: pageRegisterReviewFeedback?.totalPages,
                            setPageIndex: (pageIndex) =>
                                handleChangeFormSearchReviewFeedback({ pageIndex }),
                            setPageSize: (pageSize) =>
                                handleChangeFormSearchReviewFeedback({ pageSize }),
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default memo(observer(ListReviewFeedback));
